 
import {List, Map} from 'immutable';

import SUBJECT_STUDY_BLOG_LINKS from './subjectStudyBlogLinks';

export function getSubjectViewLinks({
  subjectSlug,
  subjectId,
  navConfig
}: {
  subjectSlug: string;
  /** The subject's UUID, used to look up a blog URL and show a "Study" tab instead of "Overview" for listed subjects. */
  subjectId: string;
  navConfig: Map<string, boolean>;
}): List<Map<string, unknown>> {
  let subjectViewLinks = List<Map<string, unknown>>();

  const hasStudyGuide = navConfig.get('studyGuide');
  if (hasStudyGuide) {
    subjectViewLinks = subjectViewLinks.push(
      Map({
        name: 'Practice',
        to: `/${subjectSlug}`
      })
    );
  }

  const hasFRQ = navConfig.get('FRQ');
  const hasFAQ = navConfig.get('FAQ');
  const hasAssessmentGuide = navConfig.get('assessments');

  const studyBlogUrl = SUBJECT_STUDY_BLOG_LINKS[subjectId];

  if (!hasFAQ && !hasFRQ && !hasAssessmentGuide && !studyBlogUrl) {
    return subjectViewLinks;
  }

  subjectViewLinks = subjectViewLinks.setIn([0, 'match'], new RegExp(`^/${subjectSlug}$`));

  if (hasFRQ) {
    subjectViewLinks = subjectViewLinks.push(
      Map({
        name: 'Free Response',
        to: `/${subjectSlug}/free-response`,
        match: new RegExp(`^/${subjectSlug}/free-response`)
      })
    );
  }

  if (hasAssessmentGuide) {
    subjectViewLinks = subjectViewLinks.push(
      Map({
        name: 'Assessments',
        to: `/${subjectSlug}/assessments`,
        match: new RegExp(`^/${subjectSlug}/assessments`)
      })
    );
  }

  if (studyBlogUrl) {
    subjectViewLinks = subjectViewLinks.push(
      Map({
        name: 'Study',
        blogUrl: studyBlogUrl,
        isExternal: true
      })
    );
  } else if (hasFAQ) {
    subjectViewLinks = subjectViewLinks.push(
      Map({
        name: 'Overview',
        to: `/${subjectSlug}/overview`,
        match: new RegExp(`^/${subjectSlug}/overview`)
      })
    );
  }

  return subjectViewLinks;
}
